import { createContext, useContext, useMemo, useState, type ReactNode } from 'react';

/**
 * Shared hover state linking a table row to its map marker (both carry the same
 * `rowRef`). The panel and the map layer are sibling subtrees, so the hovered ref
 * is lifted into a tiny context they both read/write — hovering a row lights its
 * marker and vice-versa. Purely client-side; no effect on the fetched data.
 */
interface HoverCtx {
  hovered: string | null;
  setHovered: (ref: string | null) => void;
}

const InvestigationHoverContext = createContext<HoverCtx>({ hovered: null, setHovered: () => {} });

export function InvestigationHoverProvider({ children }: { children: ReactNode }) {
  const [hovered, setHovered] = useState<string | null>(null);
  const value = useMemo(() => ({ hovered, setHovered }), [hovered]);
  return (
    <InvestigationHoverContext.Provider value={value}>{children}</InvestigationHoverContext.Provider>
  );
}

export function useInvestigationHover(): HoverCtx {
  return useContext(InvestigationHoverContext);
}
